import { Button, ButtonText } from '@/components/ui/button'
import useAppStore from '@/store/useAppStore'
import VaultSelectionPopover from '@/pages/dashboard/VaultSelectionPopover'
import SavedViewsMenu from '@/pages/dashboard/SavedViewsMenu'
import SaveViewDialog from '@/pages/dashboard/SaveViewDialog'
import DashboardRefreshControl from '@/pages/dashboard/DashboardRefreshControl'

export default function DashboardControlRow() {
  const splitByVault = useAppStore((state) => state.dashboardSplitByVault)
  const setSplitByVault = useAppStore(
    (state) => state.setDashboardSplitByVault,
  )

  return (
    <div className="flex w-full items-center gap-2 whitespace-nowrap">
      <VaultSelectionPopover />

      <button
        type="button"
        onClick={() => setSplitByVault(!splitByVault)}
        className={`flex items-center gap-1.5 rounded-lg border px-2.5 py-1.5 text-sm font-semibold ${
          splitByVault
            ? 'border-accent bg-accent-tr-12 text-txt-accent'
            : 'border-primary bg-white text-txt-primary'
        }`}
      >
        Split by vault
      </button>

      <div className="h-5 w-px bg-[hsl(var(--border-primary))]" />

      <SavedViewsMenu />

      <SaveViewDialog>
        <Button variant="ghost" size="sm">
          <ButtonText>Save view</ButtonText>
        </Button>
      </SaveViewDialog>

      <div className="ml-auto pl-2">
        <DashboardRefreshControl />
      </div>
    </div>
  )
}
